import { trigger } from '../utils/events';
import viewportDims from './viewport-dims';

let pendingUpdate = false;

export default function resize() {
	// code for resize events can go here

	if (pendingUpdate) {
		return;
	}

	pendingUpdate = true;

	requestAnimationFrame(() => {
		pendingUpdate = false;

		viewportDims();

		trigger({ event: 'modern_tribe/resize_executed', native: false });
	});
}
